/* =========================================================
   LUMIBIRD® Landing – JS
   1) Demo-Erlebnis: Warenkorb-Drawer (Desktop & Mobile)
   2) Shopify-Integration: CONFIG unten auf deinen Shop umstellen
   ========================================================= */

/* ---------------------------------------------------------
   CONFIG – HIER DEINEN SHOPIFY-SHOP EINTRAGEN
   ---------------------------------------------------------
   setup: "demo"    => Add-to-Cart öffnet den Demo-Drawer
   setup: "shopify" => Add-to-Cart verbindet sich mit Shopify

   Für "shopify" brauchst du:
   - shopDomain:     z.B. "https://dein-shop.myshopify.com" (ohne Slash am Ende)
   - variantId:      deine Shopify-Variant-ID (Zahl). Shopify-Admin:
                     Produkt öffnen -> Variante ansehen / aus der
                     URL einer Vorschauversand-Selection kopieren,
                     oder via shopDomain + "/products/<handle>.js" auslesen.
   - redirectAfterAdd: true  => direkt zum Checkout springen
                     false => Drawer zeigen und Checkout-Button nutzen */
const CONFIG = Object.assign({
  setup: "demo",                       // "demo" | "shopify"
  shopDomain: "",                      // z.B. "https://dein-shop.myshopify.com"
  productUrl: "",                      // z.B. shopDomain + "/products/lumibird-vogellampe"
  variantId: "",                       // z.B. "49123456789012"
  redirectAfterAdd: false,             // true = direkt zum Checkout
  price: 24.9,                         // Einzelpreis in EUR für Demo-Drawer
  productName: "LUMIBIRD® Vogellampe",
}, window.__LUMI_CONFIG || {});

/* ---------- kleine Helfer ---------- */
const fmtEUR = (n) => n.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "\u00A0€";
const $ = (sel, root = document) => root.querySelector(sel);
const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

/* ---------- Galerie ---------- */
(function initGallery() {
  const mainImage = $("#mainImage");
  const thumbs = $$(".thumb");
  thumbs.forEach((btn) => {
    btn.addEventListener("click", () => {
      const src = btn.dataset.src;
      if (!src || !mainImage) return;
      mainImage.style.opacity = 0;
      const pre = new Image();
      pre.onload = function () {
        mainImage.src = src;
        mainImage.style.opacity = 1;
      };
      pre.src = src;
      thumbs.forEach((t) => t.classList.remove("is-active"));
      btn.classList.add("is-active");
    });
  });
})();

/* ---------- Mengen-Zähler im Hero ---------- */
let qty = 1;
function renderQty() {
  const heroInput = $("#qtyInput");
  const cartQty = $("#cartQty");
  if (heroInput) heroInput.value = String(qty);
  if (cartQty) cartQty.textContent = String(qty);
  const linePrice = $("#cartLinePrice");
  const cartTotal = $("#cartTotal");
  const total = CONFIG.price * qty;
  if (linePrice) linePrice.innerHTML = fmtEUR(total);
  if (cartTotal) cartTotal.innerHTML = fmtEUR(total);
}
(function initQty() {
  const dec = $(".js-qty-dec");
  const inc = $(".js-qty-inc");
  if (dec) dec.addEventListener("click", () => { qty = Math.max(1, qty - 1); renderQty(); });
  if (inc) inc.addEventListener("click", () => { qty = Math.min(99, qty + 1); renderQty(); });
  if ($("#qtyInput")) {
    $("#qtyInput").addEventListener("change", (e) => {
      qty = Math.min(99, Math.max(1, parseInt(e.target.value, 10) || 1));
      renderQty();
    });
  }
  const cDec = $("#cartQtyDec");
  const cInc = $("#cartQtyInc");
  if (cDec) cDec.addEventListener("click", () => { qty = Math.max(1, qty - 1); renderQty(); });
  if (cInc) cInc.addEventListener("click", () => { qty = Math.min(99, qty + 1); renderQty(); });
  renderQty();
})();

/* ---------- Shopify-Integration ---------- */
async function shopifyAddToCart() {
  // Cart-API muß same-origin sein (funktioniert auch im Theme-Editor-Preview).
  const base = "";
  const res = await fetch(base + "/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ items: [{ id: Number(CONFIG.variantId), quantity: qty }] }),
  });
  if (!res.ok) throw new Error("Cart-API-Fehler: " + res.status);
  await res.json();
  if (CONFIG.redirectAfterAdd) {
    window.location.href = base + "/checkout";
  } else {
    openDrawer();
  }
}

/* ---------- Add-to-Cart Triggers ---------- */
function handleAddToCart() {
  if (CONFIG.setup === "shopify") {
    shopifyAddToCart().catch((err) => {
      console.error(err);
      // Fallback: Produktdetailseite in Shopify öffnen
      window.location.href = CONFIG.productUrl || "/";
    });
  } else {
    openDrawer();
  }
}
$$(".js-add-to-cart").forEach((b) => b.addEventListener("click", handleAddToCart));
if ($("#stickyBuy")) $("#stickyBuy").addEventListener("click", handleAddToCart);

/* Drawer:
   - Demo => Taste öffnet Demo-Drawer
   - Shopify ohne redirectAfterAdd => Drawer nach Add-to-Cart
     (Cart-Total kommt dann aus Shopify, siehe checkoutBtn) */
const drawer = $("#cartDrawer");
const backdrop = $("#drawerBackdrop");

function openDrawer() {
  if (!drawer) return;
  renderQty();
  drawer.setAttribute("aria-hidden", "false");
  drawer.classList.add("is-open");
  if (backdrop) {
    backdrop.hidden = false;
    requestAnimationFrame(() => backdrop.classList.add("is-open"));
  }
  document.body.style.overflow = "hidden";
}
function closeDrawer() {
  if (!drawer) return;
  drawer.setAttribute("aria-hidden", "true");
  drawer.classList.remove("is-open");
  if (backdrop) {
    backdrop.classList.remove("is-open");
    setTimeout(() => { if (backdrop) backdrop.hidden = true; }, 260);
  }
  document.body.style.overflow = "";
}
if ($("#drawerClose")) $("#drawerClose").addEventListener("click", closeDrawer);
if (backdrop) backdrop.addEventListener("click", closeDrawer);
document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeDrawer(); });
if (drawer) {
  drawer.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeDrawer();
  });
}

/* ---------- Checkout-Button im Drawer ---------- */
if ($("#checkoutBtn")) {
  $("#checkoutBtn").addEventListener("click", () => {
    if (CONFIG.setup === "shopify") {
      window.location.href = "/checkout";
    } else {
      const msg = $("#drawerMessage");
      if (msg) {
        msg.innerHTML = '<div class="drawer-message info"><strong>Demo-Bestellung.</strong> ' +
          'Sobald CONFIG.setup in <code>js/main.js</code> auf <code>shopify</code> gestellt ist, ' +
          'leitet dieser Button zum echten Shopify-Checkout weiter.</div>';
      }
    }
  });
}

/* ---------- Sticky-Buy (erst nach Hero anzeigen) ---------- */
(function initSticky() {
  const bar = $("#stickyBuy");
  const pdp = $(".pdp");
  if (!bar || !pdp || !("IntersectionObserver" in window)) return;
  const io = new IntersectionObserver(
    (entries) => entries.forEach((en) => bar.classList.toggle("is-visible", !en.isIntersecting)),
    { rootMargin: "-48px 0px 0px 0px" }
  );
  io.observe(pdp);
})();

/* ---------- Reveal-Animation ---------- */
(function initReveal() {
  const els = $$(".reveal");
  if (!("IntersectionObserver" in window)) {
    els.forEach((el) => el.classList.add("is-in"));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => entries.forEach((en) => {
      if (en.isIntersecting) {
        en.target.classList.add("is-in");
        io.unobserve(en.target);
      }
    }),
    { threshold: 0.12 }
  );
  els.forEach((el) => io.observe(el));
})();

/* ---------- Footer-Jahr ---------- */
(function initYear() {
  const y = $("#year");
  if (y) y.textContent = String(new Date().getFullYear());
})();
